import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppDispatch, useAppSelector } from "redux-share";
import { setChatRulesPopover } from "redux-share/slices/popoversSlice";
import Popover from "../popover/popover";
import { shallowEqual } from "react-redux";
import JudgeIcon from "../../icon-components/judgeIcon";
import CloseIcon from "../../icon-components/closeIcon";

const ChatRules = () => {
    const dispatch = useAppDispatch();
    const { chatRulesPopover } = useAppSelector(({ popovers: { chatRulesPopover } }) => ({ chatRulesPopover }), shallowEqual);

    const customHeader = (
        <div className="pl-w-full pl-flex pl-justify-between pl-items-center pl-pb-2">
            <div className="pl-flex pl-items-center pl-gap-2">
                <JudgeIcon className="pl-fill-z-gray-700 dark:pl-fill-dark-5" />
                <p className="pl-text-[18px] pl-font-bold pl-text-z-gray-700 dark:pl-text-dark-5">توافق‌نامه حقوقی گفت و گوی زنده</p>
            </div>
            <CloseIcon
                className="pl-stroke-secondary-400 dark:pl-stroke-dark-5 pl-cursor-pointer"
                onClick={() => dispatch(setChatRulesPopover(false))}
            />
        </div>
    );

    return (
        <>
            {conditions(ConditionName.isComplexPortrait) ? (
                <div
                    className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                    onClick={() => dispatch(setChatRulesPopover(true))}
                >
                    <JudgeIcon className={`pl-flex pl-items-center !pl-w-5 !pl-h-5 pl-fill-gray-800 dark:pl-fill-white pl-relative`} />
                    <span className="pl-whitespace-nowrap">قوانین چت</span>
                </div>
            ) : (
                <button
                    className="pl-text-main-highLight pl-text-[12px] pl-mt-[18px] pl-mb-[31px] pl-mr-2 pl-underline"
                    onClick={() => dispatch(setChatRulesPopover(true))}
                >
                    توافق‌نامه حقوقی گفت و گوی ‌زنده
                </button>
            )}
            <Popover
                status={chatRulesPopover}
                onClose={() => dispatch(setChatRulesPopover(false))}
                type="modal"
                isBlurBackground={conditions(ConditionName.isComplexDesktop)}
                isHeader={true}
                customHeader={customHeader}
                classNames="!pl-bg-white dark:!pl-bg-dark-3 pl-max-w-[639px] pl-py-4"
                isHasCatchUpLineOnTop={conditions(ConditionName.isComplexPortrait)}
            >
                <div className="pl-px-4 pl-text-[14px] pl-font-medium">
                    <p className="pl-mb-4">توافقنامه استفاده از سرویس گفت‌وگوی پخش زنده ذره‌بین</p>
                    <p className="pl-mb-4 pl-text-justify">
                        قسمت گفت‌وگوی زنده در پخش زنده ذره‌بین به منظور ایجاد فضایی برای تبادل نظر به شکلی سریع و ساده در دسترس کاربران قرار گرفته
                        است. به کمک این بخش کاربران می‌توانند با یکدیگر و با استریمر ارتباط داشته باشند. با این حال، برای داشتن یک بخش گفت‌وگوی سالم و
                        دوستانه، رعایت موارد زیر ضروری است:
                    </p>
                    <div className="pl-text-justify">
                        <p>1. از توهین به دیگران جدا پرهیز کنیم.</p>
                        <p>
                            2. شخصیت مجازی ما جلوه‌ای از شخصیت حقیقی ماست، پس سعی کنیم همان‌طور که در دنیای واقعی با احترام کامل با دیگران رفتار
                            می‌کنیم، در قسمت گفت‌وگو هم احترام یکدیگر را نگه داشته و به یکدیگر بی‌احترامی نکنیم.
                        </p>
                        <p>
                            3. اگر از سوی کاربری شاهد توهین و بی‌احترامی بودیم، به جای وارد شدن به بحث تنها از استریمر و مدیران گفت‌وگوی زنده بخواهیم
                            تا قسمت گفت‌وگو را مدیریت کنند.
                        </p>
                        <p>4. از ایجاد بحث‌های جنجالی خودداری کنیم.</p>
                        <p>
                            5. یادمان باشد که ایجاد یک بحث جنجالی می‌تواند منجر به ارسال پیام‌های نامناسب از سوی کاربران دیگر هم باشد، پس مسبب ایجاد
                            کدورت میان دیگر کاربران نشویم.
                        </p>
                        <p>6. اطلاعات شخصی خود را به هیچ وجه در قسمت گفت‌وگوی زنده منتشر نکنید.</p>
                        <p>7. اگر خواهان احترام به حریم شخصی از سوی دیگران هستیم، در ابتدا خودمان باید مراقب حریم شخصی خود باشیم.</p>
                        <p>
                            8. کاربران موظفند در هنگام استفاده از بخش گفت‌وگوی زنده، کلیه قوانین و مقررات حقوقی جاری کشور را رعایت نمایند. این شامل
                            پرهیز از هرگونه فعالیتی است که ممکن است نقض قانون تلقی شود، از جمله انتشار محتوای غیرقانونی، تبلیغات غیرمجاز، و نقض حقوق
                            معنوی و مادی دیگران. توجه و احترام به این قوانین اساسی برای حفظ یک فضای سالم و قانونمند در گفت‌وگوهای زنده ضروری است.
                        </p>
                        <p>
                            9. سعی کنیم تا با استریمر و مدیران گفت‌وگوی زنده کمال همکاری را داشته باشیم و آن‌ها را در راستای مدیریت هرچه بهتر بخش
                            گفت‌وگوی زنده یاری دهیم.
                        </p>
                        <p>
                            10. تابع قوانینی باشیم که از سوی استریمر برای بخش گفت‌وگوی زنده تعیین شده است. مطمئنا داشتن یک فضای سالم و صمیمانه برای
                            گفت‌وگو، در گروی رعایت همین قوانین است.
                        </p>
                    </div>
                </div>
            </Popover>
        </>
    );
};

export default ChatRules;
